import IBaseStepModel from "./interfaces/BaseStepModel.interface";

export interface IRegiftCardStep extends IBaseStepModel {
    value: number;
}

export class RegiftCardStepModel implements IRegiftCardStep, IBaseStepModel {
    value: number;
    isDirty: boolean;

    constructor(
    ) {
        this.value = 0;
    }

    static validateModel(model: IRegiftCardStep, cardBalance:number) {

        if (!model) return false;

        return model.value > 0 && model.value <= cardBalance;
    }
}